
import React from "react";
import { Tables } from "@/integrations/supabase/types";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { MapPin, Calendar, AlertCircle } from "lucide-react";
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableHeader, 
  TableRow 
} from "@/components/ui/table";
import { format } from "date-fns";
import { Badge } from "@/components/ui/badge";

type CrimeReport = Tables<"crime_reports">;

interface CrimeListProps {
  crimeReports: CrimeReport[];
}

const CrimeList: React.FC<CrimeListProps> = ({ crimeReports }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Crime Reports</CardTitle>
      </CardHeader>
      <CardContent>
        {crimeReports.length === 0 ? (
          <div className="text-center py-8 text-muted-foreground">
            No crime reports available
          </div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Date</TableHead>
                <TableHead>Category</TableHead>
                <TableHead>Location</TableHead>
                <TableHead>Description</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {crimeReports.map((report) => (
                <TableRow key={report.id}>
                  <TableCell>
                    <div className="flex items-center">
                      <Calendar className="h-4 w-4 mr-2 text-muted-foreground" />
                      {format(new Date(report.created_at), "MMM d, yyyy")}
                    </div>
                  </TableCell>
                  <TableCell>
                    <Badge 
                      variant={
                        report.category === "Sexual Harassment" ? "destructive" : 
                        report.category === "Civic Disorder" ? "default" : "secondary"
                      }
                    >
                      {report.category}
                    </Badge>
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center">
                      <MapPin className="h-4 w-4 mr-2 text-muted-foreground" />
                      {report.location_name || `${report.latitude.toFixed(4)}, ${report.longitude.toFixed(4)}`}
                    </div>
                  </TableCell>
                  <TableCell className="max-w-xs truncate">
                    {report.description || "No description provided"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};

export default CrimeList;
